module.exports = __webpack_public_path__ + "img/west-spring-1920x550.6e3db8b0.jpg";